// @ts-ignore
import Quill from '@cimpress-technology/quill/core';

export const { Attributor, Scope } = Quill.import('parchment');

export default new Attributor('strokeColor', 'data-stroke-color', { scope: Scope.INLINE });
export const BlockStrokeColorAttributor = new Attributor(
    'blockStrokeColor',
    'data-stroke-color',
    { scope: Scope.BLOCK },
);
